module.exports = __webpack_public_path__ + "static/img/_flowered-1.22b5e40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/_flowered-1.jpg
// module id = FFF4
// module chunks = 1